var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"monaco-editor",style:(`height: ${_vm.height}vh; width: ${_vm.width}%; ${_vm.float};`)})
}
var staticRenderFns = []

export { render, staticRenderFns }